export function requiresFreshAiImages(vehicle) {
  // Legacy rejections predate the persisted flag, so omission must fail secure.
  return vehicle?.fresh_ai_images_required !== false;
}

export function needsFreshBaselineCapture({ status, baselineStale, freshAiImagesRequired }) {
  if (status === "rejected") return freshAiImagesRequired !== false;
  return Boolean(baselineStale);
}

export function vehicleRejectionBody(reason, freshAiImagesRequired = true) {
  const body = { fresh_ai_images_required: freshAiImagesRequired !== false };
  const cleanReason = (reason || "").trim();
  if (cleanReason) body.reason = cleanReason;
  return body;
}
